import { Navigate, createFileRoute } from '@tanstack/react-router';

import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/datahub/periods')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.reportingPeriods'),
  }),
  component: DatahubReportingPeriodsRedirect,
});

function DatahubReportingPeriodsRedirect() {
  return <Navigate to="/settings/reporting-periods" replace />;
}
